<script setup>
import { computed } from "vue";

import { isSessionInPlanning } from "@/utils/sessionPhase";

import Badge from "./ui/Badge.vue";

const props = defineProps({
  session: { type: Object, required: true },
});

const inPlanning = computed(() => isSessionInPlanning(props.session));
</script>

<template>
  <Badge v-if="inPlanning" class="session-phase-badge" color="primary" size="x-small">
    in Planning
  </Badge>
</template>
